import React, { Component } from "react";
import {  Switch, Redirect } from "react-router-dom";

import Header from "components/Admin/Header/Header";
import Footer from "components/Admin/Footer/Footer";
import Sidebar from "components/Admin/Sidebar/Sidebar";

import dashboardRoutes from "routes/dashboard.jsx";
import {  AdminAuthRoute } from 'helper/PrivateRouteAdmin';
import { alertActions } from 'redux/actions/alert-actions';
import { connect } from 'react-redux';
import MessageCom from "./Message"
import { history } from 'helper/history';
// import Favicon from 'react-favicon';
// import faviconImage from "assets/img/favicon.png";

import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/css/animate.min.css";
import "../../assets/sass/light-bootstrap-dashboard.css?v=1.2.0";
import "../../assets/css/demo.css";
import "../../assets/css/pe-icon-7-stroke.css";
import "../../assets/fonts/robotoFont.css";

class DashboardPage extends Component {
  constructor(props) {
    super(props);
    // console.log('dashboard routes')
    history.listen((location, action) => {
      const { dispatch } = this.props;
        dispatch(alertActions.clear());
    });
  }

  componentDidMount(){
    document.title = "MUSIC ADJUDICATOR"
  }
  render() {
    // require('bootstrap/dist/css/bootstrap.min.css')
    // require('../../assets/css/animate.min.css')
    // require('../../assets/sass/light-bootstrap-dashboard.css?v=1.2.0')
    // require('../../assets/css/demo.css')
    // require('../../assets/css/pe-icon-7-stroke.css')
    // require('../../assets/fonts/robotoFont.css')
    
    return (
      <div className="wrapper">
        { /*<Favicon url={faviconImage} />*/ }
        <Sidebar {...this.props} />
        <div id="main-panel" className="main-panel" ref="mainPanel">
          <Header {...this.props} />
          <div>
            <MessageCom showModal={true} />
          </div>
          <Switch>
            {
              dashboardRoutes.map((prop, key) => {
                // console.log("prop redirect", prop.redirect);
                if (prop.redirect){
                  return <Redirect from={prop.path} to={prop.to} key={key} test="haha" />;
                }
                // console.log('prop.path 111', prop.path);
                return (
                    <AdminAuthRoute   path={prop.path}  component={prop.component} key={key}  />
                  );
                
              })
            }
          </Switch>
          <Footer />
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
    const { alert } = state;
    const typeOfAlert = typeof alert.message;
    return {
        alert,
        typeOfAlert
    };
}

const Dashboard = connect(mapStateToProps)(DashboardPage);

export default Dashboard;



// WEBPACK FOOTER //
// ./src/layouts/Dashboard/Dashboard.jsx